import request from "@/utils/request";
export function getPage(condition, pagination) {
  return request({
    url: "/hc/payapply/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}

export function saveOrUpdate(data) {
  return request({
    url: "/hc/payapply/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/hc/payapply/get",
    method: "get",
    params: { id },
  });
}

export function submit(id) {
  return request({
    url: "/hc/payapply/submit",
    method: "post",
    data: { id: id },
  });
}
export function deleteById(id) {
  return request({
    url: '/hc/payapply/deleteById',
    method: 'post',
    data: { id: id }
  })
}